import { useSelector } from 'react-redux';

const useProfileIds = () => {
  const currentUser = useSelector(state => state.auth.currentUser);

  try {
    return currentUser.profile_ids || [];
  } catch {
    return [];
  }
};

export default useProfileIds;
